import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Content = styled.div`
  min-height: 445px !important;
  padding: 35px 35px 0px 35px !important;
  background: rgba(106,226,206,1);
  background: -moz-linear-gradient(left, rgba(106,226,206,1) 0%, rgba(129,198,237,1) 100%);
  background: -webkit-gradient(left top, right top, color-stop(0%, rgba(106,226,206,1)), color-stop(100%, rgba(129,198,237,1)));
  background: -webkit-linear-gradient(left, rgba(106,226,206,1) 0%, rgba(129,198,237,1) 100%);
  background: -o-linear-gradient(left, rgba(106,226,206,1) 0%, rgba(129,198,237,1) 100%);
  background: -ms-linear-gradient(left, rgba(106,226,206,1) 0%, rgba(129,198,237,1) 100%);
  background: linear-gradient(to right, rgba(106,226,206,1) 0%, rgba(129,198,237,1) 100%);

  @media screen and (max-width: 1200px) {
    min-height: 456px !important;
  }

  @media screen and (max-width: 1035px) {
    min-height: 504px !important;
  }
`;

const Line = styled.div`
  height: 20px;
  width: 100%;
  border-bottom: 1px dashed #fff;
  margin-bottom: 10px;
`;

const H3 = styled.h3`
  color: #fff;
  font-size: 24px;
  margin: 0;
  line-height: 48px;
  font-weight: 700;

  @media screen and (max-width: 768px) {
    text-align: center;
    font-size: 20px;
    line-height: 36px;
  }
`;

const UL = styled.ul`
  font-size: 18px;
  color: #4C7196;
  padding-top: 10px;
  padding-right: 20px;
`;

const StyledWrap = styled.div`
  display: ${props => (props.active ? '' : 'none')};
`;

function FeatureCarouselItem({ feature, active }) {
  const Photo = feature.photo;
  const Icon = feature.icon;
  return (
    <StyledWrap active={active}>
      <div className="col-md-4 no-padding">
        <Photo />
      </div>
      <Content className="col-md-8">
        <Icon />
        <H3>{feature.title}</H3>
        <Line />
        <UL>
          {
            feature.descriptions
          }
        </UL>
      </Content>
    </StyledWrap>
  );
}

FeatureCarouselItem.propTypes = {
  feature: PropTypes.shape({
    photo: PropTypes.func,
    icon: PropTypes.func,
    title: PropTypes.string,
    descriptions: PropTypes.array,
  }),
};

FeatureCarouselItem.defaultProps = {
  feature: PropTypes.shape({
    photo: () => { },
    icon: () => { },
    title: '',
    descriptions: [],
  }),
};

export default FeatureCarouselItem;



// WEBPACK FOOTER //
// ./src/components/landing/FeatureCarousel/FeatureCarouselItem.js